module.exports = __webpack_public_path__ + "static/img/fail.173bc8b6.png";